function overflowParents(el) {
  const out = [];
  let node = el?.parentElement;
  while (node && node !== document.body && node !== document.documentElement) {
    const style = window.getComputedStyle(node);
    if (/(auto|scroll|overlay)/.test(`${style.overflow} ${style.overflowY} ${style.overflowX}`)) {
      out.push(node);
    }
    node = node.parentElement;
  }
  return out;
}

/** Enough of the target is visible for the tour highlight to make sense. */
export function isTourTargetInView(el, { pad = 48 } = {}) {
  if (!el || typeof window === "undefined") return false;
  const rect = el.getBoundingClientRect();
  if (!(rect.width > 0 || rect.height > 0)) return false;
  const vh = window.innerHeight || 0;
  const vw = window.innerWidth || 0;
  return (
    rect.bottom > pad &&
    rect.top < vh - pad &&
    rect.right > pad &&
    rect.left < vw - pad
  );
}

function scrollWindowToCenter(el, behavior) {
  const rect = el.getBoundingClientRect();
  const vh = window.innerHeight || 0;
  const nextTop = window.scrollY + rect.top - vh / 2 + rect.height / 2;
  window.scrollTo({
    top: Math.max(0, nextTop),
    left: 0,
    behavior,
  });
}

function scrollOverflowParentToCenter(node, el) {
  const nodeRect = node.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();
  const delta =
    elRect.top + elRect.height / 2 - (nodeRect.top + nodeRect.height / 2);
  if (Math.abs(delta) < 4) return;
  node.scrollTop += delta;
}

export function scrollHighlightIntoView(el, { fromTop = false, reduced = false } = {}) {
  if (!el || typeof window === "undefined") return;
  const behavior = reduced ? "auto" : "smooth";
  if (fromTop) {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    overflowParents(el).forEach((node) => {
      node.scrollTop = 0;
      node.scrollLeft = 0;
    });
  }
  const run = () => {
    overflowParents(el).forEach((node) => scrollOverflowParentToCenter(node, el));
    scrollWindowToCenter(el, fromTop ? (reduced ? "auto" : "smooth") : behavior);
    try {
      el.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: fromTop ? (reduced ? "auto" : "smooth") : behavior,
      });
    } catch {
      /* older WebViews */
    }
  };
  if (fromTop) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(run));
  } else {
    run();
  }
}
